import { enumeration } from '@dazn/peng-html5-tools-utils';
var DebugVerbosityLevel = enumeration({
    /**
     * Only errors will be output to the console
     */
    ERROR: 1,
    /**
     * Errors and warnings will be output to the console
     */
    WARN: 2,
    /**
     * Errors, warnings and logs will be output to the console (default)
     */
    LOG: 3,
    /**
     * Errors, warning, logs, and info will be output to console (verbose)
     */
    INFO: 4,
});
export { DebugVerbosityLevel };
//# sourceMappingURL=DebugVerbosityLevel.js.map